export default function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./~/@popperjs/core/lib/utils/expandToHashMap.js
// module id = 141
// module chunks = 1